import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SDKTabsComponent } from './sdk-tabs.component';

@NgModule({
  imports: [
    SDKTabsComponent,
  ],
  exports: [
    SDKTabsComponent,
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})

export class SDKTabsModule { }
